module.exports = __webpack_public_path__ + "img/icon.9428cb41.png";